export class NumberUDF {

  public thingTypeFieldId: number;

  public time: number;

  public value: number;


  constructor(value: number) {
    this.value = value;
  }
}



// WEBPACK FOOTER //
// ./src/models/UDFs/NumberUDF.ts